import AxiosClient from "../../../services/axios.services";

class CoursesServices {
  getCourse = (params) =>
    AxiosClient.get(
      "/api/app/carrera_cursos/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getCourseByID = (id) =>
    AxiosClient.get(
      `/api/app/carrera_cursos/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveCourse = (data) =>
    AxiosClient.post(
      "/api/app/carrera_cursos/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editCourse = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_cursos/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteCourse = (id) =>
    AxiosClient.delete(
      `/api/app/carrera_cursos/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new CoursesServices();
